/* global app */
/* global event */
/* global calendar */
/* global templateAllowedFields */
app.controller('templateCtrl', ['$rootScope', '$scope', '$http', '$compile', 'NetworkService', 'AtlasDialog', 'AtlasNotification', function($rootScope, $scope, $http, $compile, NetworkService, AtlasDialog, AtlasNotification) {

    $scope.allowedFieldsWithBrackets = templateAllowedFields;
    
    $scope.saveButtonClicked = function(content) {
        var url = window.location.href.split("/");
        var templateId =  url[url.length-1];
        NetworkService.callOperation("updatetemplate", {content:content, templateId: templateId},function(){
            AtlasNotification.info("Änderungen wurden gespeichert.")
        })
    }

    $scope.editorChanged = function() {
        $scope.hasInvalidFields = false;
        var fields = $scope.quill.root.innerText.match(/\[[A-z]*\]/g);
        if (fields != null) {
            fields.forEach(function(field) {
                var field = field.replace("[","").replace("]","");
                if ($scope.allowedFieldsWithBrackets.indexOf(field) == -1) {
                    $scope.hasInvalidFields = true;
                    AtlasNotification.error("Das Feld " + field + " ist nicht erlaub")
                }
            })
        }
        if ($scope.hasInvalidFields) {
            $scope.disableSave()
        }
        else {
            $scope.enableSave()
        }
    }
}])
